export default __webpack_public_path__ + "static/laminas_4-8c5ea8f04b6bfd6ac1f4a815233055d3.png";